// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Feed, Icon, Label } from "semantic-ui-react";
import "./HistoryMenuItem.less";
import * as i18n from "../../../config/i18n";
import { ApplicationMenuItem } from "../../../components/ApplicationMenu";
import { ApplicationWindow } from "../../../components/ApplicationWindow";
import { HistoryEtat } from "../History";
import { getApplicationClassName, getClassName } from "../../../components/utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("history", "item");
const etatIcon = {
  creation: "add",
  modification: "pencil",
  suppression: "trash"
};
const etatColor = {
  creation: "green",
  modification: "orange",
  suppression: "red"
};
const etatType = {
  creation: "creation",
  modification: "modification",
  suppression: "suppression"
};
export const HistoryMenuItem = props => {
  const {
    adresse,
    titre,
    description,
    etat,
    date,
    type,
    utilisateur
  } = props;
  const HistoryIconOpen = React.useMemo(() => /*#__PURE__*/_jsx(Icon, {
    name: "share square",
    link: true
  }), []);
  const OpenAction = React.useMemo(() => ({
    key: "open",
    icon: HistoryIconOpen,
    title: i18n.navigationOpenTab
  }), []);
  const content = React.useMemo(() => /*#__PURE__*/_jsxs("div", {
    className: getClassName(className, {
      creation: etat === HistoryEtat.creation,
      modification: etat === HistoryEtat.modification,
      suppression: etat === HistoryEtat.suppression
    }),
    children: [/*#__PURE__*/_jsx(Icon, {
      name: etatIcon[etat],
      color: etatColor[etat],
      size: "small"
    }), /*#__PURE__*/_jsx("span", {
      children: titre
    })]
  }), [titre, etat]);
  const title = React.useMemo(() => /*#__PURE__*/_jsx(Feed, {
    className: "history",
    children: /*#__PURE__*/_jsxs(Feed.Event, {
      children: [/*#__PURE__*/_jsxs(Feed.Content, {
        children: [/*#__PURE__*/_jsx(Label, {
          ribbon: "right",
          color: etatColor[etat],
          children: `${etatType[etat]} de ${type}`
        }), /*#__PURE__*/_jsx(Feed.Date, {
          children: date
        }), /*#__PURE__*/_jsx(Feed.Summary, {
          children: titre
        })]
      }), /*#__PURE__*/_jsx(Feed.Extra, {
        children: description
      }), /*#__PURE__*/_jsxs(Feed.Meta, {
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "user",
          color: "grey",
          size: "tiny",
          circular: true,
          inverted: true
        }), utilisateur?.nom, " ", utilisateur?.prenom]
      })]
    })
  }), [titre, etat, date, type, description, utilisateur]);
  return /*#__PURE__*/_jsx(ApplicationWindow, {
    path: adresse,
    "data-sentry-element": "ApplicationWindow",
    "data-sentry-component": "HistoryMenuItem",
    "data-sentry-source-file": "HistoryMenuItem.tsx",
    children: ({
      onOpen
    }) => /*#__PURE__*/_jsx(ApplicationMenuItem, {
      content: content,
      title: title,
      actions: [etat !== HistoryEtat.suppression && {
        ...OpenAction,
        onClick: onOpen
      }].filter(Boolean),
      path: etat !== HistoryEtat.suppression && adresse,
      offset: 2,
      direction: "row",
      popup: true,
      link: etat !== HistoryEtat.suppression
    })
  });
};